module.exports = __webpack_public_path__ + "assets/img/IMG039.a33955d4.png";